module.exports = __webpack_public_path__ + "media/img/vca/prizes/ifly-2d0613ac39d35cae3ef732488fa6d491.png";